export default "__VITE_ASSET__eea64403__"